import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/tv-data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500 group-hover:text-primary-400 transition-colors"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-50 tracking-wide">
              51<span className="text-primary-500">影视</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === (cat.slug === 'all' ? '/' : `/category/${cat.slug}`)
                    ? 'text-primary-500'
                    : 'text-foreground-400 hover:text-foreground-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-400 hover:text-foreground-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视..."
                className="w-48 h-9 pl-9 pr-3 rounded-full bg-background-200/70 border border-background-300/60 text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
              </div>
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-300 hover:text-foreground-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/60 py-4">
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    location.pathname === (cat.slug === 'all' ? '/' : `/category/${cat.slug}`)
                      ? 'bg-primary-500/10 text-primary-500'
                      : 'text-foreground-400 hover:bg-background-200/50 hover:text-foreground-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === '/about'
                    ? 'bg-primary-500/10 text-primary-500'
                    : 'text-foreground-400 hover:bg-background-200/50 hover:text-foreground-100'
                }`}
              >
                关于我们
              </Link>
              <div className="relative mt-2 px-3">
                <input
                  type="text"
                  placeholder="搜索影视..."
                  className="w-full h-9 pl-9 pr-3 rounded-full bg-background-200/70 border border-background-300/60 text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
                <div className="absolute left-6 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-foreground-500 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}